import { type IEbayMarketplace } from '@mahawi/eshop-common/src/types';
import { type RootState } from '@reducers';
import { Button, Col, Divider, Popconfirm, Row, Space, Typography } from 'antd';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../../hooks/use-app-dispatch';
import {
  ebayInventoryItemDelete,
  ebayInventoryItemLoad,
  ebayInventoryItemPut,
  ebayInventoryItemsClearAllResponses,
} from '../../../reducers/ebay/reducer';
import { SPACING } from '../../../theme/tokens';
import Link from '../../link';

function EBayInventoriesContainer({
  Marketplaces,
}: {
  Marketplaces: IEbayMarketplace[];
}): React.ReactElement {
  const dispatch = useAppDispatch();
  const Ebay = useSelector((s: RootState) => s.Ebay);
  const Product = useSelector((s: RootState) => s.Product);
  const [inventoryResponse, setInventoryResponse] = React.useState({});

  const ebayInventoryItemsJson = JSON.stringify(Ebay.inventoryItems);

  useEffect(() => {
    Marketplaces.forEach((marketplace) => {
      let element = <>---</>;

      if (Ebay.inventoryItems[marketplace.code]) {
        element = (
          <pre>
            <small>
              {JSON.stringify(
                Ebay.inventoryItems[marketplace.code].response,
                null,
                2,
              )}
            </small>
          </pre>
        );
      }

      setInventoryResponse((prevState) => {
        const newState = { ...prevState, [marketplace.code]: element };

        return newState;
      });
    });
  }, [Marketplaces, Ebay.inventoryItems, ebayInventoryItemsJson]);

  return (
    <>
      <Space size={SPACING.lg} align="start">
        <Button
          size="large"
          onClick={() => {
            dispatch(ebayInventoryItemsClearAllResponses());
          }}
        >
          Clear all responses
        </Button>

        <Button
          size="large"
          type="primary"
          onClick={() => {
            Marketplaces.map(
              (marketplace) =>
                Product.mpn &&
                dispatch(ebayInventoryItemLoad(Product.mpn, marketplace.code)),
            );
          }}
          disabled={Ebay.inProcess}
        >
          Load All
        </Button>

        <Button
          size="large"
          danger
          onClick={() => {
            Marketplaces.map((marketplace) =>
              dispatch(ebayInventoryItemPut(Product.uuid, marketplace.code)),
            );
          }}
          disabled={Ebay.inProcess}
        >
          Put All
        </Button>
      </Space>

      {Marketplaces.map((marketplace) => {
        return (
          <Row key={marketplace.code}>
            <Col span={24}>
              <Divider titlePlacement="start">
                <Space size={SPACING.lg} align="start">
                  {marketplace.name}
                  <Link
                    to={`/ebay/marketplace/${marketplace.code}`}
                    openInNewTab
                  />
                </Space>
              </Divider>

              <Space orientation="vertical" size={SPACING.lg} align="start">
                <Space size={SPACING.lg} align="start">
                  <Button
                    size="large"
                    type="primary"
                    onClick={() => {
                      if (Product.mpn) {
                        dispatch(
                          ebayInventoryItemLoad(Product.mpn, marketplace.code),
                        );
                      }
                    }}
                    disabled={Ebay.inProcess}
                  >
                    Load
                  </Button>

                  <Button
                    size="large"
                    danger
                    onClick={() => {
                      dispatch(
                        ebayInventoryItemPut(Product.uuid, marketplace.code),
                      );
                    }}
                    disabled={Ebay.inProcess}
                  >
                    Put
                  </Button>

                  <Popconfirm
                    placement="bottom"
                    title="Are you sure to delete this item?"
                    description="Product will be deleted from eBay marketplace."
                    onConfirm={() => {
                      if (Product.mpn) {
                        dispatch(
                          ebayInventoryItemDelete(
                            Product.mpn,
                            marketplace.code,
                          ),
                        );
                      }
                    }}
                    okText="Delete"
                    cancelText="Cancel"
                  >
                    <Button danger size="large" disabled={Ebay.inProcess}>
                      Delete
                    </Button>
                  </Popconfirm>
                </Space>

                <Typography.Text>
                  {inventoryResponse[marketplace.code]}
                </Typography.Text>
              </Space>
            </Col>
          </Row>
        );
      })}

      <br />
      <Space size={SPACING.lg} align="start">
        <Button
          size="large"
          onClick={() => {
            dispatch(ebayInventoryItemsClearAllResponses());
          }}
        >
          Clear all responses
        </Button>
      </Space>
    </>
  );
}

export default EBayInventoriesContainer;
